import Client from './Clients/AxiosClient'
import { parseFilters } from './utils/ParseFilters'
const resource = 'online_orders'

export default {
  get (filters) {
    return Client.get(`${resource}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getOnlineOrder (id, filters) {
    return Client.get(`${resource}/${id}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
      .then(response => response.data)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
      .then(response => response.data)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
      .then(response => response.data)
  },
  getOnlineOrderReport (filters) {
    return Client.get(`online_sales/online_orders_report?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getOnlineOrderTotals (filters) {
    return Client.post('online_sales/total_items/', filters)
      .then(response => response.data)
  },
  getOnlineOrdersAndItems (filters) {
    return Client.get(`online_sales/orders_and_items?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getOnlineOrderRevenueOverview (payload) {
    return Client.post('online_sales/revenue_overview', payload)
      .then(response => response.data)
  },
  getAccountsForWeeklyOrderReports () {
    return Client.get('online_sales/weekly/accounts')
      .then(response => response.data)
  },
  refundOrder (orderId, transactionId, parentId) {
    return Client.post('online_sales/refund', { orderId, transactionId, parentId, resource_check: true, resource_key: 'account_id' })
      .then(response => response.data)
  },
  getOnlineSalesOverviewReport (accountId, bUseSchoolYear, schoolYear, dateStart, dateEnd) {
    return Client.get(`online_sales/studio_overview_report?account_id=${accountId}&b_use_school_year=${bUseSchoolYear}&school_year=${schoolYear}&date_start=${dateStart}&date_end=${dateEnd}`)
      .then(response => response.data)
  },
  getNamePersonalizationList (accountId, dateRange, timezone, bUseSchoolYear, schoolYear, automationFormat) {
    return Client.get(`online_sales/personalized_order_names?accountId=${accountId}&timezone=${timezone}&range=${dateRange}&b_declined=false&b_use_school_year=${bUseSchoolYear}&school_year=${schoolYear}&automation_format=${automationFormat}`)
      .then(response => response.data)
  },
  getDistributionList (accountId, dateRange, timezone, bUseSchoolYear, schoolYear) {
    return Client.get(`online_sales/distribution_list?accountId=${accountId}&timezone=${timezone}&range=${dateRange}&b_declined=false&b_use_school_year=${bUseSchoolYear}&school_year=${schoolYear}`)
      .then(response => response.data)
  },
  getShipToHomeAddressList (accountId, dateRange, timezone, bUseSchoolYear, schoolYear) {
    return Client.get(`online_sales/ship_to_home_address_list?accountId=${accountId}&timezone=${timezone}&range=${dateRange}&b_declined=false&b_use_school_year=${bUseSchoolYear}&school_year=${schoolYear}`)
      .then(response => response.data)
  },
  getTextDedicationAdsList (accountId, dateRange, timezone, bUseSchoolYear, schoolYear) {
    return Client.get(`online_sales/text_dedication_ads_list?accountId=${accountId}&timezone=${timezone}&range=${dateRange}&b_declined=false&b_use_school_year=${bUseSchoolYear}&school_year=${schoolYear}`)
      .then(response => response.data)
  },
  getPersonalizedBookCount (payload) {
    return Client.post('online_sales/personalized_book_count', payload)
      .then(response => response.data)
  },
  getGenericBookCount (payload) {
    return Client.post('online_sales/generic_book_count', payload)
      .then(response => response.data)
  },
  getDedicationAdCount (payload) {
    return Client.post('online_sales/dedication_ad_count', payload)
      .then(response => response.data)
  },
  getTextDedicationAdCount (payload) {
    return Client.post('online_sales/text_dedication_ad_count', payload)
      .then(response => response.data)
  },
  getDonatedBookCount (payload) {
    return Client.post('online_sales/donated_book_count', payload)
      .then(response => response.data)
  },
  getBookCountsByBinding (payload) {
    return Client.post('online_sales/book_counts_by_binding', payload)
      .then(response => response.data)
  },
  getShipToHomeBookCount (payload) {
    return Client.post('online_sales/get_ship_to_home_count', payload)
      .then(response => response.data)
  },
  getDedicationAdSales (payload) {
    return Client.post('online_sales/dedication_ad_sales?built_only=1', payload)
      .then(response => response.data)
  },
  generateOrderReceipt (id) {
    return Client.get(`online_sales/receipt/${id}`)
      .then(response => response.data)
  },
  getOrderAdminPersonalizedBookCount (accountId, proofYear) {
    return Client.post('online_sales/order_admin_number_of_personalized_books', { account_id: accountId, year: proofYear })
      .then(response => response.data)
  },
  getYearToYearSalesComparison (parentId, year1, year2, ) {
    return Client.get(`online_sales/year_to_year_sales_comparison?parentId=${parentId}&year1=${year1}&year2=${year2}`)
      .then(response => response.data)
  }
}
